import { MapPin, NavigationArrow } from "@phosphor-icons/react";
import { Reveal } from "../Reveal";
import { OutlineButton } from "../GoldButton";
import { SITE } from "../../config/site";

export const Localizacao = () => {
  return (
    <section
      id="localizacao"
      data-testid="location-section"
      className="relative py-24 md:py-32 bg-paper"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <Reveal>
              <span className="font-body text-xs tracking-[0.3em] uppercase text-gold">
                Localização
              </span>
              <h2 className="font-display text-ink uppercase tracking-tight leading-[0.95] text-4xl md:text-5xl lg:text-6xl mt-5">
                Onde treinar
              </h2>
            </Reveal>
            <Reveal delay={0.08}>
              <div className="flex items-start gap-4 mt-8">
                <MapPin size={26} weight="light" className="text-gold shrink-0 mt-1" />
                <p className="font-body text-slate/85 text-lg leading-relaxed">
                  {SITE.address}
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.12}>
              <div className="mt-8">
                <OutlineButton
                  href={SITE.mapsDirections}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="location-directions"
                >
                  <NavigationArrow size={18} weight="fill" />
                  Como chegar
                </OutlineButton>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden border border-line">
              <iframe
                title="Mapa Savassi - Templo Jiu-Jitsu"
                src={SITE.mapsEmbed}
                className="w-full h-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="location-map"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
